module.exports = __webpack_public_path__ + "6380e48456c22f6b4045f981419371e9.fbx";